import styled from 'styled-components';

const Scroller = styled.div`
  padding-bottom: 4rem;
  ${Styles.desktop`
    overflow-y: auto;
  `}
`;

export default Scroller;
